class AlwaysSticky extends HTMLElement {
    constructor() {
      super();
      this.isSticky = false;
      this.stickyOffset = 0;
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      console.log('initialization')
    }

    connectedCallback() {
      this.placeholder = document.createElement('div');
      this.placeholder.style.display = 'none';
      this.parentNode.insertBefore(this.placeholder, this);

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });
      
      // Delay initial check slightly to ensure CSS variables are loaded
      setTimeout(() => {
        this.updateOffset();
        this.handleScroll();
      }, 100);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }

    updateOffset() {
      // Get the current height of the header from the CSS variable
      const headerEnd = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
      this.stickyOffset = parseFloat(headerEnd) || 0;
    }

    handleScroll() {
      const rect = this.getBoundingClientRect();
      const placeholderRect = this.placeholder.getBoundingClientRect();
      
      if (!this.isSticky) {
        if (rect.top <= this.stickyOffset) {
          this.makeFixed(rect);
        }
      } else {
        // When fixed, we check the placeholder's position to know when to un-stick
        if (placeholderRect.top > this.stickyOffset) {
          this.revertNormal();
        }
      }
    }

    handleResize() {
      this.updateOffset();
      // if (this.isSticky) {
      //   this.style.width = `${this.placeholder.offsetWidth}px`;
      //   this.style.left = `${this.placeholder.getBoundingClientRect().left}px`;
      //   this.style.top = `${this.stickyOffset}px`;
      // }
    }

    makeFixed(rect) {
      this.isSticky = true;
      
      // Match dimensions to stop jump
      this.placeholder.style.width = `${this.offsetWidth}px`;
      this.placeholder.style.height = `${this.offsetHeight}px`;
      this.placeholder.style.display = window.getComputedStyle(this).display === 'none' ? 'block' : window.getComputedStyle(this).display;
      this.placeholder.style.margin = window.getComputedStyle(this).margin;
      
      // this.style.position = 'fixed';
      // this.style.top = 'calc(var(--header-height) - 1px)';
      // this.style.left = 0;
      // this.style.right = 0;
      // this.style.zIndex = '999';
      // this.style.margin = '0';
      // this.style.background = 'var(--color-background, #fff)';
      // this.style.width = '100%';
      this.classList.add('is-sticky');
      this.querySelector('.js-always-sticky-wrapper')?.classList.add('container')
      // alert(getComputedStyle(document.documentElement).getPropertyValue('--header-end').trim() + ' ' + getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim() + ' ' + getComputedStyle(document.documentElement).getPropertyValue('--header-end-padded').trim() + ' ' + getComputedStyle(document.documentElement).getPropertyValue('--header-end-padded-mobile').trim())
    }

    revertNormal() {
      this.isSticky = false;
      this.placeholder.style.display = 'none';

      this.classList.remove( 'is-sticky');
      this.querySelector('.js-always-sticky-wrapper')?.classList.remove('container')
      
      // this.style.position = '';
      // this.style.top = '';
      // this.style.left = '';
      // this.style.width = '';
      // this.style.zIndex = '';
      // this.style.margin = '';
      // this.style.background = '';
      // this.style.width = '';
      // this.classList.remove('container')
    }
  }

  if (!customElements.get('always-sticky')) {
    customElements.define('always-sticky', AlwaysSticky);
  }